// extracted by mini-css-extract-plugin
module.exports = {"header":"_6IwWUiJcei4YygSy7giqhw==","langContainer":"oN9Pe-jRVB4qkpRJQV7Lhw==","langTitle":"kVhkk246zYzkCd0vJY71bA==","languageInputContainer":"XOPXLlkVVQwQMAReOnh4cA=="};